import { render, staticRenderFns } from "./AddPoints.vue?vue&type=template&id=3a23ef7b&scoped=true&"
import script from "./AddPoints.vue?vue&type=script&lang=js&"
export * from "./AddPoints.vue?vue&type=script&lang=js&"
import style0 from "./AddPoints.vue?vue&type=style&index=0&id=3a23ef7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23ef7b",
  null
  
)

export default component.exports